import React from 'react';
import styled from '@emotion/styled';
import { notification, Space } from 'antd';
import { Title } from 'app/components/Typography/Title';
import ICWLogo from 'assets/images/logos/icw-logo-coloured.png';
import { AuthContext } from 'app/providers/Authentication';
import { ForgotPasswordForm } from 'app/components/Forms/ForgotPassword';
import { useNavigate } from 'react-router';
const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const Content = styled.div`
  border-radius: 4px;
  background: #fff;
  padding: 48px;
  box-shadow: 10px 10px 14px 0px rgba(180, 190, 209, 0.51);
  -webkit-box-shadow: 10px 10px 14px 0px rgba(180, 190, 209, 0.51);
  -moz-box-shadow: 10px 10px 14px 0px rgba(180, 190, 209, 0.51);
  img[alt='icw-logo'] {
    width: 180px;
    margin-bottom: 16px;
    padding-left: 16px;
  }
  .ant-space {
    width: 390px;
    form {
      width: 100%;
    }
  }
  h3 {
    text-align: center;
  }
`;
export const ForgotPassword = () => {
  const { resetPassword } = React.useContext(AuthContext);
  const navigate = useNavigate();

  const submit = async (values: any) => {
    try {
      await resetPassword?.({
        ...(values as any),
        locale: 'en'
      })?.unwrap();
      navigate('/');
    } catch (error) {
      notification.error({
        message: 'Something went wrong',
        placement: 'bottomLeft'
      });
    }
  };
  return (
    <Container>
      <Space
        style={{ width: 550, marginBottom: 40 }}
        direction="vertical"
        align="center"
      >
        <img style={{ width: 250 }} src={ICWLogo} alt="icw-logo" />
      </Space>
      <Content style={{ width: 600 }}>
        <Title level={3}>Reset Password</Title>
        <div>
          <ForgotPasswordForm
            initialValues={{
              email: ''
            }}
            onFinish={submit}
          ></ForgotPasswordForm>
        </div>
      </Content>
    </Container>
  );
};
